const VERSION = "2.0.1";

// 1 stage remainning time
const REMAINING_TIME = 99;

// stage panel num horizontal
const HORIZONTAL_PANEL = 8;

// stage panel num vertical
const VERTICAL_PANEL = 8;

// view porin box num
const SELECTOR_NUM = 3;

// 1 game number of continuations
const COUNTINUE_COUNT = 3;

const MAX_WIDTH_PIXEL = 460;

const USE_TWITTER = true;

export default {
    REMAINING_TIME,
    HORIZONTAL_PANEL,
    VERTICAL_PANEL,
    SELECTOR_NUM,
    COUNTINUE_COUNT,
    MAX_WIDTH_PIXEL,
    VERSION,
    USE_TWITTER
};